// extracted by mini-css-extract-plugin
export default {"menuListSwitchContainer":"MenuListSelectAll_menuListSwitchContainer__MUHGK","selectDeselectTitle":"MenuListSelectAll_selectDeselectTitle__xt3iG"};